import React, { useRef, useState } from "react";
import { Box, Typography, Modal, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";

const successStories = [
  { id: 1, name: "Anirudha", videoUrl: "https://www.youtube.com/embed/zK38PD3SE7E?si=FZWyBM6gbXEAvpfc" },
  { id: 2, name: "Kshitija", videoUrl: "https://www.youtube.com/embed/73Q0VgbLzIk?si=zwvZq7QupN5XsuEs" },
  { id: 3, name: "Sohail", videoUrl: "https://www.youtube.com/embed/8Q4afwvEA3s?si=uAATy_9XcW5BANdr" },
  { id: 4, name: "Yuvanandhan", videoUrl: "https://www.youtube.com/embed/LHlt1OpqREM?si=CWD-jKmeT8DRrWdO" },
  { id: 5, name: "Arko Mitra", videoUrl: "https://www.youtube.com/embed/9xAkid_F3Ao?si=PdZ-0pISXo7KihJZ" },
  { id: 6, name: "Eyon", videoUrl: "https://www.youtube.com/embed/4QX7UEgL6Ag?si=U_qR9QjrBW2Mns6J" },
  { id: 7, name: "Anant", videoUrl: "https://www.youtube.com/embed/eA6r4AocL9g?si=tdzPMX3gPaYA-BHU" },
  { id: 8, name: "Ayush", videoUrl: "https://www.youtube.com/embed/Vx-Xs-2_75o?si=tcbvD0sVHWfjE7kd" },
  { id: 9, name: "Apurva", videoUrl: "https://www.youtube.com/embed/DrID61L12Pc?si=IJBy_DEeKzzuyKc8" },
  { id: 10, name: "Nilesh", videoUrl: "https://www.youtube.com/embed/nC4B0DqEu38?si=Qk78AoGTU2qj6FQW" },
  { id: 11, name: "Wasil", videoUrl: "https://www.youtube.com/embed/HiQo4aDUWfs?si=C1BygYDbKNF47ICh" },
  { id: 12, name: "Shayan", videoUrl: "https://www.youtube.com/embed/t0l52vDZOLE?si=8h27oIG_L1xbsgAN" },
  { id: 13, name: "Shubh", videoUrl: "https://www.youtube.com/embed/8BrjUoPSIBE?si=fQSagBt73n7QJvqX" },
  { id: 14, name: "Sandesh", videoUrl: "https://www.youtube.com/embed/ITApXi7175E?si=8A7lMM_im0hgpJ-I" },
  { id: 15, name: "Deeksha", videoUrl: "https://www.youtube.com/embed/EL8UXQogy80?si=NFd5vUSjFArtY6Lj" },
  { id: 16, name: "Saiteja", videoUrl: "https://www.youtube.com/embed/BVOGTbaS2dQ?si=D9Bx2fYPIqtEMM5K" },
  { id: 17, name: "Priyanka", videoUrl: "https://www.youtube.com/embed/CgKzMomjtDs?si=60m0hVrSjY2p-HYS" },
  { id: 18, name: "Sonalika", videoUrl: "https://www.youtube.com/embed/5P4a2B2WEAY?si=JGTTHjnklb2qOB6e" },
  { id: 19, name: "Rahul", videoUrl: "https://www.youtube.com/embed/z641ADFkBgw?si=fizf3ma3LeNv6tcJ" },
  { id: 20, name: "Swati", videoUrl: "https://www.youtube.com/embed/8a7uxyZEVQg?si=4H93ek-IG4mdS3ds" },
  { id: 21, name: "Abhisekh", videoUrl: "https://www.youtube.com/embed/aVJJC7lq-3U?si=9UZ8Ut81CZ2SeW_o"},
  { id: 22, name: "Malavika", videoUrl: "https://www.youtube.com/embed/Y9oTul7XjYk?si=41onOhzBi601bweG" },
  { id: 23, name: "Kashif", videoUrl: "https://www.youtube.com/embed/6OgqoT4DRv4?si=QkADeoaP26CThtG3" },
  { id: 24, name: "Prashant", videoUrl: "https://www.youtube.com/embed/0bqkK8nPuOg?si=10Db2x2w88oLgnuv" },
  { id: 25, name: "Shumail", videoUrl: "https://www.youtube.com/embed/MFOwGQK3dqg?si=QyTaJ7__N7RNHeK0" },
  { id: 26, name: "Embecya", videoUrl: "https://www.youtube.com/embed/wJJ8bc45lsw" },
  { id: 27, name: "NECA", videoUrl: "https://www.youtube.com/embed/lAcqHdPOYEk" },
];

const PlayIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff" style={{ position: "absolute" }}>
    <path d="M8 5v14l11-7z" />
  </svg>
);

export default function SuccessStoriesV3({ isSmallScreen, city }) {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const visibleCount = isSmallScreen ? 1 : 4;
  const pageCount = Math.ceil(successStories.length / visibleCount);

  const scroll = (direction) => {
    let newIndex = activeIndex + (direction === "next" ? 1 : -1);
    if (newIndex >= pageCount) newIndex = 0;
    if (newIndex < 0) newIndex = pageCount - 1;
    setActiveIndex(newIndex);
  };

  const startIdx = activeIndex * visibleCount;
  const visibleStories = successStories.slice(startIdx, startIdx + visibleCount);

  const handleCardClick = (story) => {
    setSelectedVideo(story);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedVideo(null);
  };

  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: "5%" },
        maxWidth: { xs: "100%", md: "100%" },
        mx: "auto",
        background: "#fafafa",
      }}
    >
      <Box sx={{ maxWidth: { xs: "90%", md: "80%" }, mx: "auto" }}>
        <Typography
          sx={{
            fontSize: { xs: "1.2rem", md: "1.85rem" },
            fontWeight: 700,
            color: "#1a1a2e",
            mb: 1,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Our Success Stories
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "0.9rem", md: "14.5px" },
            color: "#666",
            mb: 4,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {city ? `Watch how our graduates transformed their careers with PaperLive's DevOps course in ${city}` :"Watch how our graduates transformed their careers with PaperLive's DevOps course"}.
        </Typography>

        {/* Success Stories Carousel */}
        <Box sx={{ position: "relative", mb: 3 }}>
          {/* Left Arrow */}
          <Box
            onClick={() => scroll("prev")}
            sx={{
              position: "absolute",
              left: { xs: 0, md: -60 },
              top: "50%",
              transform: "translateY(-50%)",
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "#fff",
              border: "1.5px solid #e0e0e0",
              boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "22px",
              fontWeight: 700,
              color: "#8C00FF",
              zIndex: 10,
              transition: "background 0.15s",
              "&:hover": { background: "#f4e9ff" },
            }}
          >
            ‹
          </Box>

          {/* Stories Track */}
          <motion.div
            ref={trackRef}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            style={{
              display: "grid",
              gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(4, 1fr)",
              gap: "20px",
              paddingLeft: isSmallScreen ? 24 : 8,
              paddingRight: isSmallScreen ? 24 : 8,
            }}
          >
            {visibleStories.map((story, idx) => (
              <motion.div
                key={story.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: idx * 0.08, ease: "easeOut" }}
              >
                <Box
                  onClick={() => handleCardClick(story)}
                  sx={{
                    position: "relative",
                    borderRadius: "16px",
                    overflow: "hidden",
                    aspectRatio: "16/10",
                    cursor: "pointer",
                    boxShadow: "0 6px 22px rgba(0,0,0,0.12)",
                    display: "flex",
                    alignItems: "flex-end",
                    padding: "18px",
                    background: `
                      radial-gradient(circle at 78% 30%, rgba(0,0,0,0.05), transparent 55%),
                      repeating-radial-gradient(circle at 15% 85%, rgba(0,0,0,0.06) 0 2px, transparent 2px 9px),
                      linear-gradient(145deg, #ffb100 0%, #ff8a00 55%, #ff6b00 100%)
                    `,
                    transition: "transform 0.2s",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  {/* PL Brand */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "12px",
                      left: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "4px",
                        background: "#1a1a2e",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        color: "#fff",
                        fontSize: "11px",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      PL
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 800,
                        color: "#1a1a2e",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Paperlive Learning
                    </Typography>
                  </Box>

                  {/* Play Icon */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      background: "rgba(0,0,0,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PlayIcon />
                  </Box>

                  {/* Label at Bottom */}
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontWeight: 700,
                        color: "#fff",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        mb: "4px",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      SUCCESS STORY
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        color: "#1a1a2e",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {story.name}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            ))}
          </motion.div>

          {/* Right Arrow */}
          <Box
            onClick={() => scroll("next")}
            sx={{
              position: "absolute",
              right: { xs: 0, md: -60 },
              top: "50%",
              transform: "translateY(-50%)",
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "#fff",
              border: "1.5px solid #e0e0e0",
              boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "22px",
              fontWeight: 700,
              color: "#8C00FF",
              zIndex: 10,
              transition: "background 0.15s",
              "&:hover": { background: "#f4e9ff" },
            }}
          >
            ›
          </Box>
        </Box>

        {/* Pagination Dots */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 3 }}>
          {Array.from({ length: pageCount }).map((_, idx) => (
            <Box
              key={idx}
              onClick={() => setActiveIndex(idx)}
              sx={{
                width: idx === activeIndex ? 24 : 9,
                height: 9,
                borderRadius: "6px",
                background: idx === activeIndex ? "#FFA500" : "#ffe0b2",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            />
          ))}
        </Box>

        {/* YouTube Video Modal */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: { xs: "90%", md: "70%" },
              maxWidth: "800px",
              bgcolor: "#000",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              aria-label="Close"
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                bgcolor: "rgba(255,255,255,0.1)",
                color: "#fff",
                zIndex: 10,
                "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
              }}
            >
              <CloseIcon />
            </IconButton>

            {selectedVideo && (
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: "56.25%",
                  height: 0,
                  overflow: "hidden",
                }}
              >
                <iframe
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.name}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Box>
            )}
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}
